import { render, staticRenderFns } from "./GiftPackaging.vue?vue&type=template&id=794420b2&scoped=true"
import script from "./GiftPackaging.vue?vue&type=script&lang=js"
export * from "./GiftPackaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794420b2",
  null
  
)

export default component.exports